"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifeClassDetailRequest = void 0;
var LifeClassDetailRequest = /** @class */ (function () {
    function LifeClassDetailRequest() {
    }
    return LifeClassDetailRequest;
}());
exports.LifeClassDetailRequest = LifeClassDetailRequest;
;
//# sourceMappingURL=lifeClassDetail.request.js.map